/**
 * Import all Meilisearch settings
 *
 * File serves as an entry point for webpack.
 */
import './index.scss';
import './settings'